import { apiService } from './apiService'
import { DashboardStats } from '@types'

export const dashboardService = {
  // 获取仪表板统计数据
  async getDashboardStats(): Promise<DashboardStats> {
    return apiService.get<DashboardStats>('/dashboard/stats')
  },

  // 获取订阅趋势数据
  async getSubscriptionTrend(timeRange: string = '7d'): Promise<any> {
    return apiService.get(`/dashboard/subscription-trend?range=${timeRange}`)
  },

  // 获取收入趋势数据
  async getRevenueTrend(timeRange: string = '7d'): Promise<any> {
    return apiService.get(`/dashboard/revenue-trend?range=${timeRange}`)
  },

  // 获取用户增长数据
  async getUserGrowth(timeRange: string = '7d'): Promise<any> {
    return apiService.get(`/dashboard/user-growth?range=${timeRange}`)
  },

  // 获取热门菜园数据
  async getTopGardens(limit: number = 10): Promise<any> {
    return apiService.get(`/dashboard/top-gardens?limit=${limit}`)
  },

  // 获取最近活动
  async getRecentActivities(limit: number = 10): Promise<any> {
    return apiService.get(`/dashboard/recent-activities?limit=${limit}`)
  },

  // 获取待处理事项
  async getPendingTasks(): Promise<any> {
    return apiService.get('/dashboard/pending-tasks')
  },
}








